/**
 * InfinitSales - Widgets do site: modal do codigo do widget.
 *
 * A linha do <script> para colar no site e, no modo pagina inteira, o link
 * da pagina de conversa. Abre pelo botao de copiar do card e logo depois de
 * criar um widget.
 */
import React, { useEffect, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import WidgetModalShell, { MONO, copyText, formStyles } from './WidgetModalShell';

const WidgetSnippetModal = ({ account, onClose }) => {
  const { colors } = useTheme();
  const s = formStyles(colors);
  const [copied, setCopied] = useState(null); // 'script' | 'link' | null
  const scriptRef = useRef(null);
  const linkRef = useRef(null);
  const timerRef = useRef(null);
  useEffect(() => () => clearTimeout(timerRef.current), []);

  const script = account?.snippet?.script || '';
  const link = account?.mode === 'standalone' ? (account?.snippet?.standalone_url || '') : '';

  const copy = async (what, text, el) => {
    if (!text || !(await copyText(text, el))) return;
    setCopied(what);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setCopied(null), 2000);
  };

  // Caixa so leitura: quebra a linha em vez de rolar para o lado; um toque seleciona tudo.
  const box = {
    padding: '12px 14px', borderRadius: 10, border: `1px solid ${colors.borderColor}`,
    backgroundColor: colors.bgSecondary, color: colors.textPrimary,
    fontFamily: MONO, fontSize: 12.5, lineHeight: 1.55,
    whiteSpace: 'pre-wrap', wordBreak: 'break-all', overflowWrap: 'anywhere', userSelect: 'all',
  };
  const icon = (what) => (copied === what ? <Check size={16} /> : <Copy size={16} />);

  return (
    <WidgetModalShell
      title="Código do widget"
      subtitle={'Cole esta linha no site, antes de </body>.'}
      onClose={onClose}
      maxWidth={480}
    >
      <div ref={scriptRef} role="textbox" aria-readonly="true" aria-label="Código do widget" tabIndex={0} style={box}>
        {script}
      </div>
      <button
        type="button"
        className="wdg-btn"
        disabled={!script}
        onClick={() => copy('script', script, scriptRef.current)}
        style={{ ...s.primaryBtn, marginTop: 12 }}
      >
        {icon('script')}
        {copied === 'script' ? 'Copiado' : 'Copiar'}
      </button>

      {link && (
        <div style={{ marginTop: 20 }}>
          <div style={s.label}>Link da página</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: 8 }}>
            <div
              ref={linkRef}
              role="textbox"
              aria-readonly="true"
              aria-label="Link da página"
              tabIndex={0}
              style={{ ...box, flex: '1 1 220px', minWidth: 0 }}
            >
              {link}
            </div>
            <button
              type="button"
              className="wdg-btn"
              onClick={() => copy('link', link, linkRef.current)}
              style={{ ...s.secondaryBtn, padding: '11px 14px' }}
            >
              {icon('link')}
              {copied === 'link' ? 'Copiado' : 'Copiar'}
            </button>
          </div>
        </div>
      )}
    </WidgetModalShell>
  );
};

export default WidgetSnippetModal;
